const medicareAU = {
  green: 'Hijau',
  blue: 'Biru',
  yellow: 'Kuning',
};

export default medicareAU;
